<template>
    <div class="school-year-switcher">
        <b-select
            v-model="selectedSchoolYear"
            :options="schoolYears"
            :disabled="busy"
        ></b-select>
    </div>
</template>

<script>
import SingPause from "@/mixins/SingPause/SingPause";
import { ApiFactory } from "@/api/ApiFactory.js";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    name: "SchoolYearSwitcher",
    mixins: [SingPause],
    props: ["size"],
    data() {
        return {
            busy: false,
            schoolYears: []
        };
    },
    created() {
        this.fetchSchoolYears();
    },
    methods: {
        async fetchSchoolYears() {
            this.busy = true;
            const response = await SingPauseApi.getSchoolYears();
            if (response.ok) {
                this.schoolYears = response.json.collection.map(item => {
                    return {
                        value: item,
                        text: this.printSchoolYear(item)
                    };
                });
            }
            this.busy = false;
        }
    }
};
</script>
